// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from PaginationItem.module.scss  */
.PaginationItem-module-Root_eWX {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  margin-left: var(--pagination-item-inline-margin);
  font-size: 1em;
  line-height: 1em;
  border: var(--pagination-item-border);
  border-radius: var(--pagination-item-border-radius);
  padding-inline: var(--pagination-item-inline-padding);
  padding-block: var(--pagination-item-block-padding); }

.PaginationItem-module-Inactive_17z:hover {
  cursor: pointer;
  background-color: var(--pagination-item-background-inactive-color); }

.PaginationItem-module-Active_3wq {
  cursor: default;
  background-color: var(--pagination-item-background-active-color); }

.PaginationItem-module-Typography_3JU {
  line-height: 1em; }

.PaginationItem-module-TypographyInactive_1w- {
  color: var(--pagination-item-typography-inactive-color); }

.PaginationItem-module-TypographyActive_3Mt {
  color: var(--pagination-item-typography-active-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Pagination/Item/PaginationItem.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,mDAAmD;EACnD,qDAAqD;EACrD,mDAAmD,EAAE;;AAEvD;EACE,eAAe;EACf,kEAAkE,EAAE;;AAEtE;EACE,eAAe;EACf,gEAAgE,EAAE;;AAEpE;EACE,gBAAgB,EAAE;;AAEpB;EACE,uDAAuD,EAAE;;AAE3D;EACE,qDAAqD,EAAE","sourcesContent":["/*  imported from PaginationItem.module.scss  */\n.PaginationItem-module-Root_eWX {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: auto;\n  margin-left: var(--pagination-item-inline-margin);\n  font-size: 1em;\n  line-height: 1em;\n  border: var(--pagination-item-border);\n  border-radius: var(--pagination-item-border-radius);\n  padding-inline: var(--pagination-item-inline-padding);\n  padding-block: var(--pagination-item-block-padding); }\n\n.PaginationItem-module-Inactive_17z:hover {\n  cursor: pointer;\n  background-color: var(--pagination-item-background-inactive-color); }\n\n.PaginationItem-module-Active_3wq {\n  cursor: default;\n  background-color: var(--pagination-item-background-active-color); }\n\n.PaginationItem-module-Typography_3JU {\n  line-height: 1em; }\n\n.PaginationItem-module-TypographyInactive_1w- {\n  color: var(--pagination-item-typography-inactive-color); }\n\n.PaginationItem-module-TypographyActive_3Mt {\n  color: var(--pagination-item-typography-active-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
